import studentService from 'ApiService/Teacher/Student';
import testService from 'ApiService/Teacher/TestService';
import Card from 'components/card';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import SelectClass from 'pages/Teacher/Attendance/MarkAttendance/Class/Index';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import StepperControl from 'views/admin/main/users/newUser/components/Subject/StepperControl';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import SelectTest from './Steps/SelectTest';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [scheduledAt, setscheduledAt] = useState('');
  const [attendance, setAttendance] = useState([]);
  const [testData, setTestData] = useState({
    courseId: '',
    batchId: '',
  });
  const [startTime, setStartTime] = useState('');
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(new Set());
  const [isModalOpenConfirmation, setIsModalOpenConfirmation] = useState(false);
  const steps = [
    { stepNo: 1, name: 'Course Info' },
    { stepNo: 2, name: 'Add Details' },
  ];
  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await testService.getAllCourses();
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  async function getStudents() {
    try {
      const response = await studentService.getStudent(
        testData.courseId,
        testData.batchId
      );
      if (response.data.success) {
        setAttendance(response.data.data);
      }
    } catch (error) {
      toast.error(error);
    }
  }

  const handleConfirmAssign = () => {
    if (!selectedTest || selectedStudent.length === 0) {
      toast.error(
        'Please select a test and at least one batch and student to assign test'
      );
      return;
    }
    if (!scheduledAt) {
      toast.error('Please add scheduled Date');
      return;
    }
    setIsModalOpenConfirmation(true);
  };

  const handleAssignTest = async () => {
    if (loading) return;
    if (!selectedTest || selectedStudent.length === 0) {
      toast.error(
        'Please select a test and at least one batch and student to assign test'
      );
      return;
    }
    if (!scheduledAt) {
      toast.error('Please add scheduled Date');
      return;
    }
    setLoading(true);
    const payload = {
      testId: selectedTest,
      scheduledAt,
      startTime,
      students: selectedStudent,
    };
    try {
      const response = await testService.assignRetestToStudents(payload);
      if (response.data.success) {
        toast.success('Test assigned successfully');
        fetchCourses();
        setCurrentStep(1);
        setIsModalOpenConfirmation(false);
      } else {
        toast.error(response.data.message || 'Failed to assign test.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to assign test.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const clearData = () => {
    setAttendance([]);
  };

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectClass
            setLoading={setLoading}
            setDisable={setDisable}
            courses={courses}
            setClassData={setTestData}
            classData={testData}
            loadingCourses={loadingCourses}
            clearData={clearData}
          />
        );
      case 2:
        return (
          <SelectTest
            setLoading={setLoading}
            setDisable={setDisable}
            testData={testData}
            selectedTest={selectedTest}
            setSelectedBatches={setSelectedBatches}
            setSelectedTest={setSelectedTest}
            selectedBatches={selectedBatches}
            setscheduledAt={setscheduledAt}
            scheduledAt={scheduledAt}
            setStartTime={setStartTime}
            startTime={startTime}
            getStudents={getStudents}
            attendance={attendance}
            selectedStudent={selectedStudent}
            setSelectedStudent={setSelectedStudent}
          />
        );
      default:
        return null;
    }
  };

  const handleNext = async () => {
    if (disable) return;
    setLoading(true);
    setCurrentStep(currentStep + 1);
    setLoading(false);
  };

  const handleBack = () => {
    if (disable) return;
    setCurrentStep((cs) => cs - 1);
  };

  const handleKeyDown = (event) => {
    if (disable) return;

    if (event.key === 'Enter') {
      if (currentStep === 1) {
        handleNext();
      }
    } else if (event.key === 'ArrowLeft') {
      if (currentStep > 1) {
        handleBack();
      }
    } else if (event.key === 'ArrowRight') {
      if (currentStep < steps.length) {
        handleNext();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentStep, disable]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = (direction) => {
    let newStep = currentStep;

    direction === 'next' ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  return (
    <div className="md-mt-[3] mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>
        <Card extra={'h-full mx-auto pb-3'}>
          <div className="rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {/* navigation button */}
          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            loading={loading}
            disable={disable || loading}
            handleSubmit={
              currentStep === steps.length ? handleConfirmAssign : handleClick
            }
            // handleSubmit={handleAssignTest}
          />
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpenConfirmation}
        onClose={() => {
          if (!loading) setIsModalOpenConfirmation(false);
        }}
        onConfirm={handleAssignTest}
        title="Confirm ReTest Assignment"
        message={`Are you sure you want to assign this test to ${selectedStudent?.length} selected students?`}
        confirmText={loading ? 'Assigning...' : 'Yes, Assign Re-Test'}
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default Index;
